import billingModule from '../../billing.module';
import template from './billingModalEnrollAutoPay.component.html';
import style from './billingModalEnrollAutoPay.component.scss';

export default billingModule.component('billingModalEnrollAutoPay', {
    template,
    style,
    bindings: {
        modalInstance: '<'
    },
    controller: function(billingAccountService) {
        let vm = this;

        vm.isSavingAutoPay = false;

        vm.submitEnrollAutoPay = function() {
            vm.isSavingAutoPay = true;

            billingAccountService
                .updateBillingAccount({
                    autoPay: true
                })
                .then(
                    () => vm.modalInstance.close(true),
                    () => vm.modalInstance.close(false)
                )
                .finally(() => {
                    vm.isSavingAutoPay = false;
                });
        };

        vm.closeModal = function() {
            vm.modalInstance.close();
        };
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-modal-enroll-auto-pay/billingModalEnrollAutoPay.component.js